const ColorPicker = ELEMENT.ColorPicker;
const PickerDropdown = ColorPicker.components.PickerDropdown;
const isEyeDropper = !!window.EyeDropper;

ColorPicker.mixins.push({
  watch: {
    showPicker(to) {
      this.$emit('visible-change', to);
    }
  }
});

if (isEyeDropper) {
  let render = PickerDropdown.render;
  PickerDropdown.render = function (h) {
    let vNode = render.call(this, h);
    let children = vNode.componentOptions.children[0].children;
    let _vNode = _.last(children);
    _vNode.children.unshift(<label class="dropper" title="取色器" onClick={this.doEyeDropper}>
      <DsfIcon name="a-5" />
    </label>);
    return vNode;
  }
  PickerDropdown.created = function () {
    this.eyeDropper = new EyeDropper();
  }
  PickerDropdown.methods.doEyeDropper = function () {
    this.eyeDropper.open()
      .then((res) => {
        this.color.fromString(res.sRGBHex);
      })
      .catch(dsf.noop);
  }
}